import { render } from "./BrandStyriaDigitalServices.vue?vue&type=template&id=92ee50ca"
import script from "./BrandStyriaDigitalServices.vue?vue&type=script&lang=ts"
export * from "./BrandStyriaDigitalServices.vue?vue&type=script&lang=ts"

import "./BrandStyriaDigitalServices.vue?vue&type=style&index=0&id=92ee50ca&lang=scss"
script.render = render

export default script